module.exports = __webpack_public_path__ + "static/media/mosque.c66957c3.svg";